import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Form, Pagination, InputGroup, Modal } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import axios from 'axios';
import { BsPencilSquare, BsTrash, BsSearch, BsSortDown, BsSortUp } from 'react-icons/bs';
import { API_ENDPOINTS } from '../config'; // Import updated API endpoints


const Alltransaction = () => {
  const [transection, setTransection] = useState([]);
 

  const fetchTransection = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(API_ENDPOINTS.getAllTransection, {
        headers: { token }
      });
      //console.log(response.data.data)
      setTransection(response.data.data);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

   useEffect(() => {
    fetchTransection();
  }, []);

 
  return (
    <div className="d-flex">
      <Sidebar style={{ position: 'fixed', top: 0, bottom: 0, left: 0, width: '250px', zIndex: 1000 }} />
      <div style={{  width: 'calc(100%)', height: 'calc(100vh)', overflowY: 'auto' }}>
        <Header style={{ position: 'fixed', top: 0, left: '250px', width: 'calc(100% - 250px)', zIndex: 1000 }} />
        <Container fluid className="mt-3">
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h2>All Transactions</h2> 
               
              </div>
              
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Trn Id</th>
                    <th>Amount</th>
                    <th>Currency</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {transection.map((trans, index) => (
                    <tr key={trans.trn_id}>
                    <td>{trans.trn_id}</td>
                    <td>$ {trans.amount}</td>
                    <td>{trans.currency.toUpperCase()}</td>
                    <td>{trans.description}</td>
                    <td>{trans.status}</td>
                    <td>{trans.date}</td>
                    
                    
                    </tr>
                  ))}
                </tbody>
              </Table>
            
            </Col>
          </Row>
        </Container>
      </div>

   
      
    </div>
  );
};

export default Alltransaction;
